<template>
  <slide-x-left-transition :duration="400+(index*100)" :delay="200+(index*50)">
    <ion-card v-if="show" mode="ios" style="margin: 0 0 20px 0px">

      <ion-item>
        <ion-label mode="md" class="ion-text-wrap">
          <p class="pulse-status" v-if="active">
            <span class="dot" title="Trwa"></span>
            <span class="dot-text">Aktywna umowa w Programie Lojalnościowym</span>
          </p>
          <p class="pulse-status disabled"  v-if="!active && status">
            <span class="dot" title="Czeka"></span>
            <span class="dot-text">Niepotwierdzona umowa</span>
          </p>
          <h3 style="margin: 10px 0">{{ name }}</h3>
          <p>NIP: {{ tax_id }}</p>
          <p>Adres: {{ full_address }}</p>
        </ion-label>
      </ion-item>

      <ion-card-content>
        <ion-row>
          <ion-col>
            <p style="margin-top: 10px" v-if="ebi"><strong>SFA:</strong> {{ ebi }}</p>
          </ion-col>
          <ion-col class="text-right">
            <ion-button mode="ios"
                        fill="outline"
                        size="small"
                        @click="goTo('PhClientsDetails', slug)"
                        style="margin-top: 6px">Zobacz szczegóły
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-card-content>

    </ion-card>
  </slide-x-left-transition>
</template>

<script>
  import goTo from '@/mixins/goto';

  export default {
    name: 'ItemPhClient',
    props: ['index','name','slug','tax_id','ebi','street','city','province','full_address','brand','active','status'],
    mixins: [goTo],
    data() {
      return {
        show: false
      }
    },
    mounted() {
      this.show = true;
    }
  }
</script>

<style lang="scss" scoped>
  ion-card-content {
    padding: 6px 12px;
    background: #ffffff;
  }
</style>